import React, { useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { Button, Box } from "@mui/material";
import AllHomeworks from "./HomeWorks/AllHomeworks";
import MyHomeworks from "./HomeWorks/MyHomeworks";
import { startTour } from "../../../redux/globalJoyrideSlice";
import { myHomeworksTourSteps } from "../../../tour/teacherPlanerTourSteps"

const HomeworkNav = () => {
  const [activeTab, setActiveTab] = useState("all");
 const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      startTour({
        activeTour: "homework-tour",
        steps: myHomeworksTourSteps(),
      })
    );
  }, [dispatch]);
  return (
    <Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2, marginLeft: 6 }}>
        <Button
          variant={activeTab === "all" ? "contained" : "outlined"}
          onClick={() => setActiveTab("all")}
        >
          All Homeworks
        </Button>
        <Button
        data-tour="homeworks-tab-my"
          variant={activeTab === "my" ? "contained" : "outlined"}
          onClick={() => setActiveTab("my")}
        >
          My Homeworks
        </Button>
      </Box>

      <Box>
        {activeTab === "all" && <AllHomeworks />}
        {activeTab === "my" && <MyHomeworks />}
      </Box>
    </Box>
  );
};

export default HomeworkNav;
